module.exports = __webpack_public_path__ + "static/img/img-about-8.8b373b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-8.png
// module id = oNaG
// module chunks = 0